import { lazy } from 'solid-js'
import { messages } from '../../pages/permission-denied-page/permission-denied-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/permission-denied-page/permission-denied-page.jsx')),
    path: '/denied',
    showFooter: true,
    showHeader: true,
    titleMessage: messages.titleMessage,
}
